import { EloCategory } from '@/components/tournament/models/elo.model';
import api from '@/lib/api';

export const getEloCategories = async (
  sportId: string,
): Promise<EloCategory[]> => {
  const response = await api.get(`/elo-categories`, {
    params: {
      sport: sportId,
    },
  });
  return response.data;
};
